import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dropdown-menu';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dialog';
import ShowFor from '@Components/ShowFor';
import { useFishDetails } from './FishDetailsContext';
import ManualChargeDialogBody from './actions/ManualChargeDialogBody';
import WalletAdjustDialogBody from './actions/WalletAdjustDialogBody';

/**
 * Every write operation available on a fish. Read surfaces stay in the panels;
 * only the mutations live here.
 */
export default function FishActionsMenu({ variant }) {
  const [openDialog, setOpenDialog] = useState(null);
  const {
    actor,
    openModal,
    setModalContent,
    setIsCancelSubOpen,
    setAdjustAmount,
    setAdjustSuccess,
    setDryError,
  } = useFishDetails();

  const hasSubscription = !!actor?.subscriptions?.length;
  const isMemberVariant = variant === 'member';

  const openLegacyModal = (content) => {
    setModalContent(content);
    openModal();
  };

  const closeWalletDialog = () => {
    setOpenDialog(null);
    setAdjustAmount('');
    setAdjustSuccess('');
    setDryError('');
  };

  return (
    <ShowFor permissions={['MEMBERS_WRITE']}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="border-input gap-2 rounded-md bg-white/5 shadow-xs"
          >
            Actions
            <ChevronDown className="size-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuItem onSelect={() => openLegacyModal('tags')}>
            Manage Tags
          </DropdownMenuItem>
          {isMemberVariant && (
            <DropdownMenuItem onSelect={() => setOpenDialog('manual-charge')}>
              Manual Charge
            </DropdownMenuItem>
          )}
          {hasSubscription && (
            <ShowFor permissions={['WALLET_WRITE']}>
              <DropdownMenuItem onSelect={() => setOpenDialog('wallet')}>
                Adjust Wallet
              </DropdownMenuItem>
            </ShowFor>
          )}
          {hasSubscription && (
            <DropdownMenuItem onSelect={() => setIsCancelSubOpen(true)}>
              Cancel Subscription
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog
        open={openDialog === 'manual-charge'}
        onOpenChange={(open) => !open && setOpenDialog(null)}
      >
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle>Manual Charge</DialogTitle>
          </DialogHeader>
          <ManualChargeDialogBody />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDialog === 'wallet'}
        onOpenChange={(open) => !open && closeWalletDialog()}
      >
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle>Adjust Wallet</DialogTitle>
          </DialogHeader>
          <WalletAdjustDialogBody />
        </DialogContent>
      </Dialog>
    </ShowFor>
  );
}
